import "./style.css";

export default function WeatherApp() {
  return <div></div>;
}
